import { Box } from '@mui/material';
import { object } from 'prop-types';
import React from 'react';
import { QRCode } from 'react-qr-svg';

const InviteQRCode = ({ employee: { magicLink } = {} }) => (
  <Box>
    {magicLink && (
      <Box sx={{ padding: '5px', width: 120, height: 120 }}>
        <QRCode value={magicLink} size={120} level="H" />
      </Box>
    )}
  </Box>
);
InviteQRCode.propTypes = {
  employee: object,
};
export default InviteQRCode;
